export default __webpack_public_path__ + "static/media/MacOS.707102c6.svg";